import React from 'react';
import { reduxForm, Field } from 'redux-form';

import Form from 'forms/Form';
import FormButton from 'forms/FormButton';
import DateField from 'forms/DateField';
import Box from 'common/Box';
import ReduxFormSelect from '../../forms/ReduxFormSelect';
import Warning from 'notifications/Warning';
import { getDayAndMonth } from '../../helpers/formatters';

import styles from './index.module.css';

const isToday = (date) => {
  const today = new Date();
  const isSameDay = today.getDate() === date.getDate();
  const isSameMonth = today.getMonth() === date.getMonth();
  const isSameYear = today.getFullYear() === date.getFullYear();
  return isSameDay && isSameMonth && isSameYear;
}

const calculateDateRange = (purchase) => {
    // disable picker if purchase isn't selected
    if (!purchase) {
      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() - 1);
      return [maxDate, maxDate];
    }

    const today = new Date();
    const curMonth = today.getMonth();
    const curDay = today.getDate();
    const circleStartDay = 5;
    const circleEndDay = 20;

    const isPendingRenewal = purchase.status === 'pending';

    // only upcoming cycle for pending renewal purchase
    if (isPendingRenewal) {
      const cycleStartDate = new Date(purchase.cycle_start_date);

      const minDate = new Date(cycleStartDate);
      const maxDate = new Date(cycleStartDate);

      if (minDate < today || isToday(minDate)) {
        minDate.setDate(today.getDate() + 1);
      }

      maxDate.setHours(23, 59, 59);
      maxDate.setDate(circleEndDay);

      return [minDate, maxDate];
    }

    // overdue purchase with cycle_start_date <= now
    if (purchase.status === 'overdue' && purchase.cycle_start_date && new Date(purchase.cycle_start_date) <= today) {
      const cycleStartDate = new Date(purchase.cycle_start_date);

      const minDate = new Date(cycleStartDate);
      const maxDate = new Date(cycleStartDate);

      if (minDate < today || isToday(minDate)) {
        minDate.setDate(today.getDate() + 1);
      }

      maxDate.setHours(23, 59, 59);
      maxDate.setDate(circleEndDay);
      
      return [minDate, maxDate];
    }

    // current cicle
    if (circleStartDay <= curDay && curDay <= circleEndDay) {
      const minDate = new Date();
      const maxDate = new Date();
      
      maxDate.setHours(23, 59, 59);
      maxDate.setDate(circleEndDay);

      if (isToday(minDate)) {
        minDate.setDate(today.getDate() + 1);
      }

      return [minDate, maxDate];
    } 
    // upcoming cycle
    else {
      const needToIncreaseMonth = circleEndDay < curDay;
      const minDate = new Date();
      const maxDate = new Date();

      minDate.setDate(circleStartDay);
      maxDate.setDate(circleEndDay);
      maxDate.setHours(23, 59, 59);

      if (needToIncreaseMonth) {
        minDate.setMonth(curMonth + 1);
        maxDate.setMonth(curMonth + 1);
      }

      if (isToday(minDate)) {
        minDate.setDate(today.getDate() + 1);
      }

      return [minDate, maxDate];
    }
    
  }
class PaymentArrangementRequestForm extends React.Component {

  render() {
    const { purchases, paymentMethods, selectedPurchase } = this.props;
    const today = new Date();
    const curDay = today.getDate();
    const circleStartDay = 5;
    const circleEndDay = 20;
    const filteredPurchases = purchases.filter(purchase => {
      if (purchase.status === 'overdue' && purchase.cycle_start_date) {
        const cycleStartDate = new Date(purchase.cycle_start_date);
        const isSameMonth = today.getMonth() === cycleStartDate.getMonth() &&
          today.getFullYear() === cycleStartDate.getFullYear();
        const daysOutOfCycle = curDay < circleStartDay || circleEndDay < curDay;
        if (cycleStartDate <= today && (!isSameMonth || daysOutOfCycle)) {
          return false;
        } 
      }

      // filter purchases without available dates
      const purchaseDateRange = calculateDateRange(purchase);
      const [purchaseMinDate, purchaseMaxDate] = purchaseDateRange; 
      if (purchaseMaxDate <= purchaseMinDate) {
        return false;
      }

      return true;
    });
    const purchasesOptions = filteredPurchases.map(purchase => {
      const purchaseDateStr = purchase.cycle_start_date || purchase.purchase_date || purchase.created_at;
      const purchaseDate = new Date(purchaseDateStr);
      const formattedPurchaseDate = getDayAndMonth(purchaseDate);
      return {
        label: `#${purchase.id}    ${formattedPurchaseDate}    $${purchase.cost.total}`,
        value: purchase.id
      }
    });
    const paymentMethodsOptions = paymentMethods.map(method => ({
      label: `****  ${method.card_last_four}`,
      value: method.id
    }));

    const [minDate, maxDate] = calculateDateRange(selectedPurchase);

    return (
      <Box>
        <Form {...this.props}  noSubmitButton>
          <div className={styles.form}>
            <div className={styles.lineWrapper}>
              <Field name="purchase_id" component={ReduxFormSelect} autoFocus ={true} label="Purchase" options={purchasesOptions} required />
            </div>
            <div className={styles.lineWrapper}>
              <Field name="payment_method_id" component={ReduxFormSelect} label="Payment method" options={paymentMethodsOptions} required />
            </div>
            <div className={styles.lineWrapper}>
              <Field
                name="arrangement_date"
                component={DateField}
                label="Date"
                placeholderText="Select Date"
                autoComplete="off"
                dateFormat="MM/dd/yyyy"
                minDate={minDate}
                maxDate={maxDate}
                disabled={maxDate < Date.now()}
                required
              />
            </div>
            <Warning name="paymentArrangementRequest" />
      
            <FormButton className={styles.submit} >
              Submit
            </FormButton>
          </div>
        </Form>
      </Box>
    )
  }
}

const validate = (values) => {
  const err = {};
  const required = ['purchase_id', 'payment_method_id', 'arrangement_date'];

  for (const field of required) {
    if (!values[field]) {
      err[field] = 'Required';
    }
  }

  return err;
}

export default reduxForm({
  form: 'paymentArrangementRequest',
  validate,
})(PaymentArrangementRequestForm);
